import { Injectable, NgZone } from "@angular/core";
import { Subject } from "rxjs";
import { FileTransferObject, FileTransfer } from "@ionic-native/file-transfer";
import { NestApiProvider, FormDataUpload } from "../shared/nestjs/nest-api";

export interface FileTransferOptions {
	options: any, // options , like fileName or etc
	nativeUri: string, // url file in native device
	url: string, // url pload
	destinationPath?: string
}

export interface FileTransferHttpOptions {
	url: string, // options , like fileName or etc
	method: string,
	body?: FormDataUpload[]
}

export interface FileTransferDownloadOptions {
	url: string;
	method: string;
	body?: object;
}

@Injectable()
export class FileTransferNative {
	public progressUpload = new Subject();

	constructor(
		private transfer: FileTransfer,
		private ngZone: NgZone,
		private nestApiProvider: NestApiProvider,
	) {
	}

	upload(params: FileTransferOptions) {
		const fileTransfer: FileTransferObject = this.transfer.create();
		fileTransfer.onProgress(this.progressEvent);
		return fileTransfer.upload(params.nativeUri, params.url, params.options);
	}

	download(params: FileTransferOptions) {
		const fileTransfer: FileTransferObject = this.transfer.create();
		fileTransfer.onProgress(this.progressEvent);
		return fileTransfer.download(params.destinationPath, params.url, true);
	}

	uploadHttp(params: FileTransferHttpOptions) {
		return this.nestApiProvider.requestUploadWithProgress(params.method, params.url, params.body);
	}

	downloadHttp(params: FileTransferDownloadOptions) {
		return this.nestApiProvider.requestBlobWithProgress(params.method, params.url, params.body);
	}

	private progressEvent = (progressEvent: ProgressEvent): void => {
		this.ngZone.run(() => {
			if (progressEvent.lengthComputable) {
				let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
				if (progress > 100) progress = 100;
				if (progress < 0) progress = 0;
				this.progressUpload.next(progress);
				console.log('native progress', progress);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/native/file-transfer.native.ts